<ul role="list" class="divide-y divide-gray-100" data-automationid="stacked-list-container">
  @for (item of config.items; track item) {
    <li
      role="button"
      tabindex="0"
      (click)="rowclicked(item, $event); $event.stopPropagation()"
      (keydown.enter)="rowclicked(item, $event); $event.stopPropagation()"
      (keydown.space)="$event.preventDefault(); rowclicked(item, $event); $event.stopPropagation()"
      data-automationid="stacked-list-row"
      class="relative flex justify-between items-center gap-x-6 py-5 cursor-pointer hover:bg-gray-50"
    >
      <div class="flex items-center gap-x-4 flex-auto">
        @if (item.insurerLogo) {
          <img
            data-automationid="stacked-list-logo-image"
            class="h-12 w-12 flex-none object-contain bg-gray-50"
            [src]="item.insurerLogo"
            alt="Insurer logo"
          />
        }
        <div class="flex flex-col min-w-0">
          <p class="text-sm font-semibold leading-6 text-gray-900" data-automationid="stacked-list-row-title">
            {{ item.title }}
          </p>
          <p class="text-xs leading-5 text-gray-500 mt-1" data-automationid="stacked-list-row-description">
            {{ item.description }}
          </p>
        </div>
      </div>
      <div class="flex shrink-0 items-center gap-x-4">
        @for (action of item.actions; track action) {
          <svg
            tabindex="0"
            role="button"
            (click)="action.handler(item, $event)"
            (keydown.enter)="action.handler(item, $event)"
            (keydown.space)="$event.preventDefault(); action.handler(item, $event)"
            [lucideIcon]="action.icon"
            [class]="action?.classes?.length || 0 > 0 ? action.classes : actionClasses"
          ></svg>
        }
        <svg
          class="h-5 w-5 flex-none text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
          data-automationid="stacked-list-row-arrow"
        >
          <path
            fill-rule="evenodd"
            d="M7.21 14.77a.75.75 0 01.02-1.06L11.168 10 7.23 6.29a.75.75 0 111.04-1.08l4.5 4.25a.75.75 0 010 1.08l-4.5 4.25a.75.75 0 01-1.06-.02z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
    </li>
  }
</ul>
